import { render, staticRenderFns } from "./TaskUpdateStatusModalCard.vue?vue&type=template&id=6ea5b65e&"
import script from "./TaskUpdateStatusModalCard.vue?vue&type=script&lang=js&"
export * from "./TaskUpdateStatusModalCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskUpdateStatusModalCard.vue?vue&type=style&index=0&id=6ea5b65e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports